import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchStudentRooms,
  joinRoomApi,
  joinRoomByCodeApi,
} from '@/api/studentRoom'

export const fetchStudentRoomsList = createAsyncThunk(
  'studentRoom/fetchRooms',
  async (searchQuery: string | undefined, thunkAPI) => {
    try {
      const response = await fetchStudentRooms(searchQuery)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const joinRoom = createAsyncThunk(
  'studentRoom/joinRoom',
  async (
    { roomId, inviteCode }: { roomId: string; inviteCode: string },
    thunkAPI
  ) => {
    try {
      const response = await joinRoomApi(roomId, inviteCode)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const joinRoomByCode = createAsyncThunk(
  'studentRoom/joinRoomByCode',
  async ({ inviteCode }: { inviteCode: string }, thunkAPI) => {
    try {
      const response = await joinRoomByCodeApi(inviteCode)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)
